// extracted by mini-css-extract-plugin
export default {"card":"desafiosCardCategoria_card__TqbMQ","image":"desafiosCardCategoria_image__ydReb","selected":"desafiosCardCategoria_selected__mLTtV"};